import { Link } from 'react-router-dom';

export const ConnectAccountTooltlip = ({
  userId,
}: {
  userId: string | undefined;
}) => {
  return (
    <div>
      To reach out to candidates, please first connect your{' '}
      <Link to={`/users/${userId}/external-accounts`}>LinkedIn account.</Link>
    </div>
  );
};
